import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.PlatformSelectField = class PlatformSelectField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.setPlatform = this.setPlatform.bind(this);
    this.getCurrentPlatform = this.getCurrentPlatform.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    this.currentPlatform = this.getCurrentPlatform();

    this.platformCallout = new AppointmentBooking.Wizard.Views.Callout({
      model: this.model,
      className: "borderless",
      template: "step/confirmation/callouts/platform",
      condition: () => !!this.model.get("validated_appointment_slot")?.id,
    });

    return this.listenTo(
      this.model,
      "change:validated_ehr_appointment_slot_id change:validated_appointment_slot",
      this.render,
    );
  }

  render() {
    super.render(...arguments);
    this.setPlatform();

    this.replaceContents(".platform-callout-container", this.platformCallout.render().el);

    return this;
  }

  // HELPER FUNCTIONS
  setPlatform() {
    const visitType = this.model.get("validated_appointment_slot").visit_type_category;
    const availablePlatforms = Object.keys(this.I18n().platforms[visitType] || {});

    if (availablePlatforms.includes(this.currentPlatform)) {
      return this.model.set({ platform: this.currentPlatform });
    } else if (availablePlatforms.length) {
      return this.model.set({ platform: availablePlatforms[0] });
    } else {
      return this.model.set({ platform: null });
    }
  }

  getCurrentPlatform() {
    let platform = "browser";
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      platform = "android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      platform = "ios";
    }

    return platform;
  }
};
AppointmentBooking.Wizard.Views.ConfirmationStep.PlatformSelectField.prototype.template =
  "step/confirmation/fields/platform_select";
AppointmentBooking.Wizard.Views.ConfirmationStep.PlatformSelectField.prototype.className =
  "appointment-booking-wizard-confirmation-step-platform-select-field";
